<template>
  <div class="grid-item">
    <div class="grid-title">{{ number }}</div>

    <div class="exampleImg">
      <img :src="imageSrc" :alt="`F2L Algorithm ${number}`" loading="lazy" />
    </div>

    <p class="exampleText">
      <span v-html="algorithm"></span>

      <br /><br />

      <template v-if="scramble">
        <b>
          <span :class="scrambleClass || 'scramble'"> SC: </span>
        </b>
        <span v-html="scramble"></span>
      </template>
    </p>

    <p v-if="additionalAlgorithm" class="exampleText">
      <span v-html="additionalAlgorithm"></span>
    </p>

    <!-- Tips toggle button -->
    <button v-if="tips" class="tips-btn" @click="showTips = !showTips">
      <b>{{ showTips ? '✕ Hide tip' : '💡 Tip' }}</b>
    </button>

    <!-- Tips panel — expands below the card -->
    <div v-if="tips && showTips" class="tips-panel">
      {{ tips }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';

const props = defineProps({
  number: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
  algorithm: {
    type: String,
    required: true,
  },
  scramble: {
    type: String,
    default: '',
  },
  scrambleClass: {
    type: String,
    default: 'scramble',
  },
  additionalAlgorithm: {
    type: String,
    default: '',
  },
  tips: { type: String, default: '' },
});

const imageSrc = computed(() => {
  try {
    return require(`@/pages/rubik/images/${props.image}`);
  } catch (e) {
    // Fallback if image not found
    return require(`@/pages/rubik/images/${props.image}`);
  }
});

const showTips = ref(false);
</script>

<style scoped>
.tips-btn {
  margin-top: 10px;
  padding: 2px 10px;
  font-size: 0.75rem;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 12px;
  cursor: pointer;
  opacity: 0.75;
  transition: opacity 0.15s;
  background: rgba(0, 144, 240, 0.45);
}
.tips-btn:hover {
  opacity: 1;
  background: rgba(0, 144, 240, 0.65);
}

.tips-panel {
  margin-top: 6px;
  padding: 8px 10px;
  font-size: 0.8rem;
  border-left: 3px solid #f08200;
  background: rgba(240, 130, 0, 0.17);
  border-radius: 0 6px 6px 0;
  line-height: 1.4;
  color: #3b3b3b;
  /*font-family: sans-serif; /* ← add this to break font inheritance too */
  letter-spacing: 0.02em; /* ← in case parent has wide spacing */
  word-spacing: normal;
  white-space: pre-line;
}
</style>
